export default class Toast {
  readonly _id!: string
  private _message!: string
  private _isModal!: boolean
  private _displayTime!: number
  private _type!: string

  constructor(data: Pick<Toast, 'message' | 'type' | 'isModal' | 'displayTime'>) {
    this._id = Date.now().toString()
    this.message = data.message
    this.type = data.type
    this.isModal = data.isModal
    this.displayTime = data.displayTime
  }

  get id(): string {
    return this._id
  }

  get message(): string {
    return this._message
  }
  set message(value: string) {
    this._message = value
  }

  // * If displayTime is higer than 0, it will auto close
  get autoClose(): boolean {
    return this._displayTime > 0
  }

  get displayTime(): number {
    return this._displayTime
  }
  set displayTime(value: number) {
    this._displayTime = value
  }

  get type(): string {
    return this._type
  }
  set type(value: string) {
    this._type = value
  }

  get isModal(): boolean {
    return this._isModal
  }
  set isModal(value: boolean) {
    this._isModal = value
  }
}
